import * as Sentry from '@sentry/react';
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import { Row, message } from "antd";
import { DeleteModal } from "components/Dialog";
import SpinLoader from "components/Loader/SpinLoader";
import { usePageTranslations } from "store/page_translations/selectors";
import { handleCreateOrUpdatePageTranslation, handleDeletePageTranslation } from "store/page_translations/thunks";
import styled from "styled-components";

import {
    Close,
    Delete,
    Translate
} from '@mui/icons-material';
import {
    IconButton,
    Modal,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import PageImagePickerEnSP from './PageImagePickerEnSp';
import BadgeButton from '../BadgeButton';

const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: '4px',
    },
}));


const PageTranslationToolbar = ({ bookId, pageId, hasPermission = true }) => {
      const showAlert = useAlert();
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [loading, setLoading] = useState(false)

    const dispatch = useDispatch()
    const [openModal, setOpenModal] = useState(false);
    const [page_contents, setPageContents] = useState([])
    const { book_pages_translations } = usePageTranslations()
    const has_page_content = useMemo(() => page_contents.find((page_content) => page_content.page == pageId), [page_contents, pageId])
    useEffect(() => {
        if (book_pages_translations && book_pages_translations[bookId]) {
            setPageContents(book_pages_translations[bookId])
        } else {
            setPageContents([])
        }
    }, [book_pages_translations, bookId])
    useEffect(() => {

    }, [pageId])

    const onUpdate = async ({ url, type }) => {
      if (!url || loading) return;
      setLoading(true);
      try {
        let payload = {};
        if (type === 'french') {
          payload = {
            id: has_page_content?.id,
            src: has_page_content?.src,
            chapter: bookId,
            page: pageId,
            french_url : url
          };
        } else {
          payload = {
            id: has_page_content?.id,
            src: url,
            chapter: bookId,
            page: pageId,
            french_url: has_page_content?.french_url || null
          };
        }

        await dispatch(handleCreateOrUpdatePageTranslation(payload));
        showAlert('Page translation updated successfully', 'success');
      } catch (error) {
        Sentry.captureException(`302 Error updating page translation: ${error}`);
        showAlert('Something went wrong!', 'error');
      } finally {
        setLoading(false);
      }
    };
    const onDelete = async () => {
        setDeleteLoader(true)
        const dt = await dispatch(handleDeletePageTranslation(has_page_content?.id));
        if(dt&&dt.success) {
            showAlert(`Translation removed successfully`,"success")
        }else{
            showAlert("Something went wrong!","error")
        }
        setDeleteLoader(false)
        setDeleteModal(false)
    }
    const onClose = () => {
        setOpenModal(false)
    }
    return (<>
        <BadgeButton
            onClick={() => {
                if (!hasPermission) {
                    message.warning('You do not have permission to access this feature.');
                    return;
                }
                setOpenModal(true);
            }}
            startIcon={<Translate />}
            showBadge={has_page_content}
            backgroundColor="#f59e0b"
        >
            En - Sp
        </BadgeButton>
        <SpinLoader dataloader={loading} />
        <DeleteModal
            deleteToggle={deleteModal}
            loading={deleteLoader}
            onDelete={onDelete}
            setDeleteToggle={setDeleteModal}
            message={`Are you sure you want to remove page translation on pageId ${pageId}?`} />
        <Modal
            open={openModal}
            onClose={onClose}
            style={{ height: "100%", width: "100%" }}
        >
            <ModalContent style={{ width: "60vw" }}>
                <Row style={{ justifyContent: "space-between" }}>
                    {has_page_content ? <IconButton
                        onClick={() => {
                            setDeleteModal(true)
                        }}
                        style={{ padding: 0 }}
                    >
                        <Delete color="secondary" />
                    </IconButton> : null}
                    <IconButton
                        onClick={() => onClose()}
                        style={{ padding: 0, marginRight: 10 }}
                    >
                        <Close color="secondary" />
                    </IconButton>
                </Row>
                <ModalConfigArea>
                    <PageImagePickerEnSP
                        src={has_page_content ? has_page_content.src : null}
                        frenchImageSrc={has_page_content ? has_page_content.french_url : null}
                        onChange={onUpdate}
                        pageId={pageId}
                        description={''}
                        onChangeDescription={()=>{}}
                        hasDescription={false}
                        isFrenchImage={true}
                    />
                </ModalConfigArea>
            </ModalContent>
        </Modal>
    </>)
}

export default PageTranslationToolbar;